<template>
  <div v-if="options && !disabled" class="form-floating" :class="'mb-'+mb">
    <select
        class="form-select form-select-solid"
        :aria-label="placeholder"
        :disabled="disabled"
        :value="modelValue"
        :required="required"
        :name="name"
        :id="id"
        @input="updateValue"
    >
      <slot name="defaultOption"></slot>
      <option
          v-for="item in options"
          v-html="item.name ?? item.title"
          :selected="modelValue === item.id"
          :value="item.id"
          :key="item.id"
      ></option>
    </select>
    <label :for="id" :class="{ required: required }" v-html="placeholder"></label>
  </div>
  <disabled-field
      v-else
      :value="getTextInOption"
      :mb="mb"
      :placeholder="placeholder"
      :required="required"
  />
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'

export default {
  name: 'SelectFieldFromModel',
  components: {DisabledField},
  props: {
    combination: null,
    placeholder: null,
    modelValue: null,
    required: false,
    disabled: null,
    options: null,
    class: null,
    name: null,
    id: null,
    mb:null
  },
  computed: {
    getTextInOption() {
      if (this.options && this.modelValue) {
        return this.options.find(item => item.id === this.modelValue).title ?? this.options.find(item => item.id === this.modelValue).name
      }
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', parseInt(event.target.value))
    },
  },
}
</script>

<style scoped>

</style>